import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MarkerCreationService } from './marker-creation.service';
import { MarkerPopupService } from './marker-popup.service';
import * as L from 'leaflet';
import { MarkerData } from '../data/models/marker-data';
import { LinesPopDto } from '../data/models/lines-pop-dto';
//import { MarkerClusterGroup } from "leaflet.markercluster";
import { AggregationPopStatusDto } from '../data/models/aggregation-pop-status-dto';
import { AntPath, antPath } from 'leaflet-ant-path';

@Injectable({
  providedIn: 'root'
})
export class MarkerService {
 // markerCluster = new MarkerClusterGroup();



  linepopMarkersArray: MarkerData[] = [];

  polyLinesArray: any[] = [];
  polyline: any;



  constructor(private http: HttpClient, private popup: MarkerPopupService,
    private markerCreation: MarkerCreationService) { }


  drawAllmarkers(map: L.map, pops: AggregationPopStatusDto[]) {
    pops.forEach(p => {
      this.DrawMarker(map, p);
    })
  }
  ////clustered
  //async drawAllmarkers(map: L.Map, pops: any) {
  //  this.markerCluster.clearLayers();
  //  this.deleteAntPolyLines(map);
  //  for (let i = 0; i < pops.length; i++) {
  //    let marker = await this.markerCreation.createMarkerSign(pops[i]);
  //    this.markerCluster.addLayer(marker);
  //  }
  //  map.addLayer(this.markerCluster);
  //}

  removeAllMarkers(map: L.Map) {
    this.linepopMarkersArray.forEach(p => {
      map.removeLayer(p.popMarker);
    })
    this.linepopMarkersArray = [];
  }

  async DrawMarker(map: L.Map, pop: AggregationPopStatusDto) {
    //if (this.markerCluster) {
    //  map.removeLayer(this.markerCluster);
    //}
    
    if (pop != null) {
      let marker = new L.Marker<any>([0, 0]);
      marker = await this.markerCreation.createMarkerSign(pop);
      this.linepopMarkersArray.push({ popId: pop.id, popMarker: marker });
      //this.addMarkersToMap(map, this.popsMarkersArray);
      this.addMarkersToMap(map, marker);
    }
  }

  addMarkersToMap(map: L.Map, pop) {
    //array.forEach(m => m.siteMarker.addTo(map));
    pop.addTo(map);
  }



  drawPolyLineByHQ(map: L.map, pops: AggregationPopStatusDto[]) {
    //var latlngs = [
    //  [27.8206, 30.8025],
    //  [28.8206, 31.8025],
    //  [27.306, 30.4025]
    //];

    //L.polyline(latlngs, { color: 'red' }).addTo(map);
    //get HQ if not exist get first element...
    let HqExist = pops.filter(p => p.isHQ > 0)
    let primarySiteLatLong;
    if (HqExist.length > 0) {
      HqExist.sort(x => x.lineSummition).reverse();
      primarySiteLatLong = [HqExist[0].latitude, HqExist[0].longitude];
    }
    else
     primarySiteLatLong = [pops[0].latitude, pops[0].longitude]

    for (var i = 0; i < pops.length; i++) {
      if (pops[i].latitude == primarySiteLatLong[0] && pops[i].longitude ==primarySiteLatLong[1]) 
        continue;
      
      let antPolyLine = new AntPath([
        primarySiteLatLong,
        [pops[i].latitude, pops[i].longitude],
      ], {
        use: L.polyline, color: 'green', weight: 2
      });


      antPolyLine.addTo(map);
      this.polyLinesArray.push({ popId: pops[i].id, antPolyLinePath: antPolyLine });
    }

  }



  deleteAntPolyLines(map: L.Map) {  //, antpolylinesArray:any[]
    this.polyLinesArray.forEach(a => {
      map.removeLayer(a);
      let removedIndex = this.polyLinesArray.findIndex(p => a.popId == p.Id);
      this.polyLinesArray.splice(removedIndex, 1);
      return true;
    })
    //return false;
  }




  async RemoveMarker(map: L.Map, pop: any) {
    let result = await this.deleteMarkersFromMap(map, pop.id);
    if (result) {
      let ind = this.linepopMarkersArray.findIndex(s => s.popId == pop.id);
      this.linepopMarkersArray.splice(ind, 1);
    }
  }



  
  async deleteMarkersFromMap(map: L.map, siteid: number) {
    let result = false;
    await this.linepopMarkersArray.forEach(m => {
      if (m.popId == siteid) {
        map.removelayer(m.popMarker);
        result = true;
      }
    });
    return result;
  }




 
}
